import { initializeApp } from "firebase/app";
import {
	collection,
	doc,
	getDoc,
	getFirestore,
	setDoc,
	addDoc,
	query,
	getDocs,
	deleteDoc,
	where,
	updateDoc,
} from "firebase/firestore";
import {
	getDownloadURL,
	getStorage,
	ref,
	uploadBytesResumable,
} from "firebase/storage";
import {
	getAuth,
	onAuthStateChanged,
	createUserWithEmailAndPassword,
	signInWithEmailAndPassword,
	updateProfile,
	signOut,
	EmailAuthProvider,
	reauthenticateWithCredential,
	updatePassword,
} from "firebase/auth";

const firebaseConfig = {
	apiKey: "AIzaSyDZ_l5HMerMP8eTgMr9_ABeCyzIh9LLU_8",
	authDomain: "john-trucking.firebaseapp.com",
	projectId: "john-trucking",
	storageBucket: "john-trucking.appspot.com",
	messagingSenderId: "455049645554",
	appId: "1:455049645554:web:f7aa3f869556b399292f6b",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
export {
	db,
	storage,
	auth,
	onAuthStateChanged,
	createUserWithEmailAndPassword,
	signInWithEmailAndPassword,
	updateProfile,
	signOut,
	collection,
	getDoc,
	setDoc,
	doc,
	uploadBytesResumable,
	ref,
	getDownloadURL,
	EmailAuthProvider,
	reauthenticateWithCredential,
	updatePassword,
	query,
	getDocs,
	addDoc,
	deleteDoc,
	where,
	updateDoc,
};
